'use client';

import { ThemeProvider } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { SWRConfig } from 'swr';
import CssBaseline from '@mui/material/CssBaseline';
import { theme } from '@/lib/theme';
import { ConfirmProvider } from 'material-ui-confirm';
import MuiXLicense from './MuiXLicense';
import { AuthenticationProvider } from './AuthenticationProvider';
import { IntlProvider } from './IntlProvider';
import { ShellContextProvider } from './ShellContext';
import { SnackbarProvider } from './SnackbarProvider';
import { DatadogProvider } from '@/components/DatadogProvider/DatadogProvider';
import { LaunchDarklyProvider } from './LaunchDarklyProvider';
import HeartBeatProvider from './HeartBeat';

export interface ProvidersProps {
  children: React.ReactNode;
}

export const Providers = ({ children }: ProvidersProps) => {
  return (
    <LaunchDarklyProvider>
      <DatadogProvider>
        <MuiXLicense />
        <SWRConfig
          value={{
            revalidateIfStale: false,
            revalidateOnFocus: false,
          }}
        >
          <HeartBeatProvider>
            <ThemeProvider theme={theme} defaultMode="system">
              <CssBaseline />
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <AuthenticationProvider>
                  <IntlProvider>
                    <SnackbarProvider>
                      <ConfirmProvider>
                        <ShellContextProvider>{children}</ShellContextProvider>
                      </ConfirmProvider>
                    </SnackbarProvider>
                  </IntlProvider>
                </AuthenticationProvider>
              </LocalizationProvider>
            </ThemeProvider>
          </HeartBeatProvider>
        </SWRConfig>
      </DatadogProvider>
    </LaunchDarklyProvider>
  );
};
